import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Loader } from 'ui-components/src';
import { Footer } from 'ui-home/src/features/MainLayout/Footer';
import { Header } from 'ui-home/src/features/MainLayout/Header';
import Layout from 'ui-home/src/Layout/Layout';
import Logs from './src/Logs/Logs';
import styles from './src/admin.module.css';
import ErrorBoundary from './ErrorBoundry';

const Admin = () => {
  const leftNavGen2Flag = useSelector((state) => state.user.leftNavGen2);
  const isLeftNavGen2Enabled = Boolean(parseInt(leftNavGen2Flag, 10));

  const RenderHeader = () => {
    if (isLeftNavGen2Enabled) return <Layout />;

    return <Header />;
  };

  return (
    <div className={styles.page}>
      <RenderHeader />
      <div className={styles.container}>
        <ErrorBoundary>
          <Suspense key="UI-Admin" fallback={<Loader />}>
            <Router basename="/ECMv6">
              <Route exact path="/admin/logs" component={Logs} />
              <Route exact path="/admin/adminHome/manageLogs" component={Logs} />
            </Router>
          </Suspense>
        </ErrorBoundary>
      </div>
      {!isLeftNavGen2Enabled && (
        <div className={styles.footer}>
          <Footer />
        </div>
      )}
    </div>
  );
};

export default Admin;
